import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Stack,
  Box,
  Chip,
  Grid,
  IconButton,
} from '@mui/material';
import { X, Users } from 'lucide-react';

export const ConsumersModal = ({
  isOpen = false,
  onClose = () => {},
  queueName = '',
  consumers = [],
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Users style={{ width: 22, height: 22, color: '#0284c7' }} />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
              Active Consumers for {queueName}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {consumers.length} worker{consumers.length === 1 ? '' : 's'} attached and listening
            </Typography>
          </Box>
        </Stack>
        <IconButton size="small" onClick={onClose}>
          <X style={{ width: 18, height: 18 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3, maxHeight: '60vh', overflowY: 'auto' }}>
        {consumers.length === 0 ? (
          <Box sx={{ py: 6, textAlign: 'center' }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              No active consumers are currently listening to this queue.
            </Typography>
          </Box>
        ) : (
          <Stack spacing={2}>
            {consumers.map((c, idx) => (
              <Box
                key={idx}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  bgcolor: '#fff',
                }}
              >
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#10b981' }} />
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 700 }}>
                      {c.consumer_tag}
                    </Typography>
                  </Stack>
                  <Chip
                    label="Active"
                    size="small"
                    sx={{
                      height: 20,
                      fontSize: '0.65rem',
                      fontWeight: 700,
                      bgcolor: 'rgba(16, 185, 129, 0.12)',
                      color: '#059669',
                    }}
                  />
                </Stack>

                <Grid container spacing={1.5} sx={{ pt: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
                  <Grid item xs={6}>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                      Channel:
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem', fontWeight: 600 }}>
                      {c.channel_details?.name || 'Local channel'}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                      Node:
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem', fontWeight: 600 }}>
                      {c.channel_details?.node || '-'}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                      Prefetch Count:
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.8rem' }}>
                      {c.prefetch_count ?? 0}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                      Manual Ack:
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.8rem' }}>
                      {c.ack_required ? 'Required (Yes)' : 'Auto-ack (No)'}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
};
